export { SUPPORT_CATEGORIES } from './support.ts';
